import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tooltip from '@mui/material/Tooltip';

import { FlightListLastUpdate_flight$key } from '__generated__/FlightListLastUpdate_flight.graphql';
import formatDistance from 'date-fns/formatDistance';
import { locale } from 'const';

type Props = {
  flight: FlightListLastUpdate_flight$key;
};

const FlightListLastUpdate: FC<Props> = ({ flight }) => {
  const { lastSuccessfulUpdate } = useFragment(
    graphql`
      fragment FlightListLastUpdate_flight on Flight {
        lastSuccessfulUpdate {
          createdAt
        }
      }
    `,
    flight
  );

  if (lastSuccessfulUpdate) {
    return (
      <Tooltip title={lastSuccessfulUpdate.createdAt}>
        <span>
          {formatDistance(
            new Date(lastSuccessfulUpdate.createdAt),
            new Date(),
            { locale, addSuffix: true }
          )}
        </span>
      </Tooltip>
    );
  } else {
    return <>---</>;
  }
};

export default FlightListLastUpdate;
